export const RISING_STAR_PAGE_DESCRIPTION =
  'The Bash Rising Star Award winners represent the top-booked entertainers and party vendors in the U.S. and Canada. The awards are distributed annually to those members who have earned the most revenue from bookings.';
